module.exports = __webpack_public_path__ + "img/website.9c1f1dfe.svg";